import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {InsuredPersonDTO} from '../models/InsuredPersonDTO';
import {InsuredPersonWithDatesDTO} from '../models/InsuredPersonWithDatesDTO';
import {InsuredPersonStatusDTO} from '../../other/models/InsuredPersonStatusDTO';
import {FileDTO} from '../../clm/models/FileDTO';

@Injectable({
  providedIn: 'root'
})
export class InsuredPersonService {
  private url = environment.baseUrl + '/insured-person';
  private ignUrl = environment.baseIgnUrl;

  documentCode = {
    TAX: "TAX",
    CERTIFICATE_OF_MEMBERSHIP:"COM",
    MEMBER_STATEMENT: "STM"
  }

  constructor(private httpClient: HttpClient) {
  }

  getListOfInsuredPersons(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<InsuredPersonDTO>> {
    return this.httpClient.post<PagedResponseDTO<InsuredPersonDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getInsuredPersonWithDates(insuredPersonId: number, policyId: number, productId: number): Observable<InsuredPersonWithDatesDTO> {
    let params = new HttpParams();
    params = params.set('insuredPersonId', String(insuredPersonId));
    params = params.set('policyId', String(policyId));
    params = params.set('productId', String(productId));
    return this.httpClient.get<InsuredPersonWithDatesDTO>(this.url + '/byInsuredPersonIdAndPolicyId', {params});
  }

  getInsuredPersonStatusByCardOrIDNumber(searchValue: string, isSearchByCardNumberSelected: boolean): Observable<InsuredPersonStatusDTO> {
    let params = new HttpParams();
    params = isSearchByCardNumberSelected ? params.set('cardNumber', searchValue) : params.set('idNumber', searchValue);
    return this.httpClient.get<InsuredPersonStatusDTO>(this.url + '/status-lookup', {params});
  }

  getInsuredPerson(insuredPersonId: number): Observable<InsuredPersonDTO> {
    return this.httpClient.get<InsuredPersonDTO>(this.url + '/' + insuredPersonId);
  }

  deleteInsuredPerson(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }

  getListOfAssociatedPerson(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<any>> {
    return this.httpClient.post<PagedResponseDTO<any>>(this.url + '/filter', pagedRequestDTO);
  }

  addInsuredPerson(payload, isAddedDependent = false): Observable<any> {
    const url = isAddedDependent
      ? this.ignUrl + '/application-onboard/dependent'
      : this.url;
    return this.httpClient.post<any>(url, payload);
  }

  getInsuredPersonByNationalIdNumber(idNumber: string): Observable<InsuredPersonDTO> {
    return this.httpClient.get<InsuredPersonDTO>(this.url + '/getByIdNumber?idNumber=' + idNumber);
  }

  getPolicyLinkedPersons(policyId: number, productId?: number, processingClassId?: number): Observable<InsuredPersonDTO[]> {
    let params = new HttpParams();

    if (productId != null) {
      params = params.set('policyId', String(policyId));
      params = params.set('productId', String(productId));
    }
    else if (processingClassId != null) {
      params = params.set('policyId', String(policyId));
      params = params.set('processingClassId', String(processingClassId));
    }
    else {
      params = params.set('policyId', String(policyId));
    }

    return this.httpClient.get<InsuredPersonDTO[]>(this.url, {params});
  }

  private getDocumentFile(membershipNumber: string, productCode: string, documentCode: string, params: HttpParams): Observable<FileDTO> {
    params = params.set('documentCode', documentCode);
    params = params.set('membershipNumber', membershipNumber);
    params = params.set('productCode', productCode);

    return this.httpClient.get<FileDTO>(`${this.ignUrl}/application-onboard/file`, {params});
  }

  getTaxFile(membershipNumber: string, productCode: string, taxYear: string): Observable<FileDTO> {
    let params = new HttpParams();
    if (taxYear) {
      params = params.set('taxYear', taxYear);
    } else {
      throw new Error("No tax year selected")
    }
    return this.getDocumentFile(membershipNumber, productCode, this.documentCode.TAX, params);
  }

  getCertificateOfMembership(membershipNumber: string, productCode: string): Observable<FileDTO> {
    let params = new HttpParams();
    return this.getDocumentFile(membershipNumber, productCode, this.documentCode.CERTIFICATE_OF_MEMBERSHIP, params);
  }

  getMemberStatement(membershipNumber: string, productCode: string, yearMonth:string): Observable<FileDTO> {
    let params = new HttpParams();
    if (yearMonth) {
      params = params.set('yearMonth', yearMonth);
    } else {
      throw new Error("No year month selected")
    }
    return this.getDocumentFile(membershipNumber, productCode, this.documentCode.MEMBER_STATEMENT, params);
  }





}
